import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function TruthSection() {
  return <section className="py-24 bg-gym-dark relative overflow-hidden" data-id="element-297">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gym-gold to-transparent opacity-30" data-id="element-298"></div>

      <div className="max-w-4xl mx-auto px-4" data-id="element-299">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-300">
          <div className="flex justify-center mb-6" data-id="element-301">
            <AlertTriangle size={48} className="text-red-500" data-id="element-302" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-12 uppercase tracking-wide text-white" data-id="element-303">
            La verdad que los gimnasios masivos{' '}
            <span className="text-red-500" data-id="element-304">no te dicen</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed font-body text-left max-w-3xl mx-auto" data-id="element-305">
            <p data-id="element-306">Los grandes gimnasios de Lima ganan dinero con una cosa:</p>
            <p className="text-2xl font-bold text-white uppercase tracking-wider" data-id="element-307">
              Que pagues la mensualidad y no vayas.
            </p>

            <ul className="space-y-4 my-8 pl-4 border-l-2 border-gym-charcoalLight" data-id="element-308">
              <li className="flex items-start gap-3" data-id="element-309">
                <span className="text-red-500 font-bold mt-1" data-id="element-310">×</span>
                <span data-id="element-311">Su modelo de negocio depende de que abandonas.</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-312">
                <span className="text-red-500 font-bold mt-1" data-id="element-313">×</span>
                <span data-id="element-314">
                  Por eso no tienen instructores que te sigan de cerca.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-315">
                <span className="text-red-500 font-bold mt-1" data-id="element-316">×</span>
                <span data-id="element-317">Por eso nadie te pregunta cómo estás comiendo.</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-318">
                <span className="text-red-500 font-bold mt-1" data-id="element-319">×</span>
                <span data-id="element-320">
                  Por eso nadie te ajusta el plan cuando tu cuerpo se estanca.
                </span>
              </li>
            </ul>

            <p data-id="element-321">
              Entras, haces algo, te vas. Y el mes siguiente vuelves a pagar.
              Sin resultados. Sin guía. Sin plan real.
            </p>

            <div className="mt-12 p-8 bg-red-950/20 border border-red-900/50 rounded-xl text-center" data-id="element-322">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white uppercase tracking-wide" data-id="element-323">
                Eso no es un gimnasio.
                <br data-id="element-324" />
                <span className="text-red-400" data-id="element-325">
                  Eso es una sala de máquinas con música.
                </span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}